import { SET_USER_DATA, REMOVE_USER_DATA } from "./type";

const authState = {
  user: null,
};

const authReducers = (...anyArgs) => {
  const state = reducer0(...anyArgs);
  // console.trace("redux, auth, before, ", ...anyArgs);
  // console.trace("redux, auth,", state);
  document.getStateAuth = () => state;
  return state;
}

const reducer0 = (state = authState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return { ...state, user: { ...state.user, ...action.payload } };
    case REMOVE_USER_DATA:
      return { ...state, user: null };
    default:
      return state;
  }
};

export default authReducers;
